import React, { Component } from 'react';
import CartItem from './CartItem';

class CartItemsWrapper extends Component {
    render() {
        return (
            <div className="row mt-1 ml-1 mr-1">
                <div className="col-12">

                    {/* Info Banner - outside the card */}
                    <div style={{ backgroundColor: '#dceefb', padding: '10px 16px', border: '1px solid #b3d4ed', borderRadius: '4px', marginBottom: '8px' }}>
                        <p style={{ margin: 0, color: '#1a4f72', fontSize: '13px', lineHeight: '1.5' }}>
                            <strong>Note:</strong> In case the requested item is not available in our current inventory, Voorent will provide brand-new inventory. For new items, a 12-month advance/security deposit or No-Cost EMI option will be applicable.
                        </p>
                    </div>

                    {/* Card */}
                    <div style={{ border: '1px solid #DDD', borderRadius: '4px', overflow: 'hidden' }}>

                        {/* Order Details Header */}
                        <h6 className="pt-3 pb-3 pl-3 pr-3 font-weight-bold mb-0"
                            style={{ background: '#f8f9fa', borderBottom: '1px solid #eee' }}>
                            Order Details
                        </h6>

                        {/* Cart Items */}
                        <div className="row p-3">
                            <div className="col-12">
                                {this.props.cart.showCart == 0 && (
                                    <React.Fragment>
                                        <div className="row text-center m-auto">
                                            <div className="col-12">
                                                <div className="spinner-border"></div>
                                                <span className="font-weight-bold ml-3"> Loading Cart Items . . </span>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                )}

                                {this.props.cart.showCart && this.props.cart.cart.cartProductList.map((product, pIndex) => (
                                    <React.Fragment key={pIndex}>
                                        <CartItem
                                            manageQuantity={this.props.manageQuantity}
                                            manageQuantityCart={this.props.manageQuantityCart}
                                            deleteProductFromCart={this.props.deleteProductFromCart}
                                            product={product} />
                                        {pIndex < this.props.cart.cart.cartProductList.length - 1 && <hr />}
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

export default CartItemsWrapper;